/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  Button,
  Flex,
  Grid,
  SwitchField,
  TextField,
} from "@aws-amplify/ui-react";
import { fetchByPath, getOverrideProps, validateField } from "./utils";
import { generateClient } from "aws-amplify/api";
import { getCarrier } from "../graphql/queries";
import { updateCarrier } from "../graphql/mutations";
const client = generateClient();
export default function CarrierUpdateForm(props) {
  const {
    id: idProp,
    carrier: carrierModelProp,
    onSuccess,
    onError,
    onSubmit,
    onValidate,
    onChange,
    overrides,
    ...rest
  } = props;
  const initialValues = {
    carrierName: "",
    bukcet: "",
    iataode: "",
    contractType: "",
    emailAddress: "",
    isActive: false,
  };
  const [carrierName, setCarrierName] = React.useState(
    initialValues.carrierName
  );
  const [bukcet, setBukcet] = React.useState(initialValues.bukcet);
  const [iataode, setIataode] = React.useState(initialValues.iataode);
  const [contractType, setContractType] = React.useState(
    initialValues.contractType
  );
  const [emailAddress, setEmailAddress] = React.useState(
    initialValues.emailAddress
  );
  const [isActive, setIsActive] = React.useState(initialValues.isActive);
  const [errors, setErrors] = React.useState({});
  const resetStateValues = () => {
    const cleanValues = carrierRecord
      ? { ...initialValues, ...carrierRecord }
      : initialValues;
    setCarrierName(cleanValues.carrierName);
    setBukcet(cleanValues.bukcet);
    setIataode(cleanValues.iataode);
    setContractType(cleanValues.contractType);
    setEmailAddress(cleanValues.emailAddress);
    setIsActive(cleanValues.isActive);
    setErrors({});
  };
  const [carrierRecord, setCarrierRecord] = React.useState(carrierModelProp);
  React.useEffect(() => {
    const queryData = async () => {
      const record = idProp
        ? (
            await client.graphql({
              query: getCarrier.replaceAll("__typename", ""),
              variables: { id: idProp },
            })
          )?.data?.getCarrier
        : carrierModelProp;
      setCarrierRecord(record);
    };
    queryData();
  }, [idProp, carrierModelProp]);
  React.useEffect(resetStateValues, [carrierRecord]);
  const validations = {
    carrierName: [{ type: "Required" }],
    bukcet: [{ type: "Required" }],
    iataode: [{ type: "Required" }],
    contractType: [{ type: "Required" }],
    emailAddress: [{ type: "Required" }],
    isActive: [],
  };
  const runValidationTasks = async (
    fieldName,
    currentValue,
    getDisplayValue
  ) => {
    const value =
      currentValue && getDisplayValue
        ? getDisplayValue(currentValue)
        : currentValue;
    let validationResponse = validateField(value, validations[fieldName]);
    const customValidator = fetchByPath(onValidate, fieldName);
    if (customValidator) {
      validationResponse = await customValidator(value, validationResponse);
    }
    setErrors((errors) => ({ ...errors, [fieldName]: validationResponse }));
    return validationResponse;
  };
  return (
    <Grid
      as="form"
      rowGap="15px"
      columnGap="15px"
      padding="20px"
      onSubmit={async (event) => {
        event.preventDefault();
        let modelFields = {
          carrierName,
          bukcet,
          iataode,
          contractType,
          emailAddress,
          isActive: isActive ?? null,
        };
        const validationResponses = await Promise.all(
          Object.keys(validations).reduce((promises, fieldName) => {
            if (Array.isArray(modelFields[fieldName])) {
              promises.push(
                ...modelFields[fieldName].map((item) =>
                  runValidationTasks(fieldName, item)
                )
              );
              return promises;
            }
            promises.push(
              runValidationTasks(fieldName, modelFields[fieldName])
            );
            return promises;
          }, [])
        );
        if (validationResponses.some((r) => r.hasError)) {
          return;
        }
        if (onSubmit) {
          modelFields = onSubmit(modelFields);
        }
        try {
          Object.entries(modelFields).forEach(([key, value]) => {
            if (typeof value === "string" && value === "") {
              modelFields[key] = null;
            }
          });
          await client.graphql({
            query: updateCarrier.replaceAll("__typename", ""),
            variables: {
              input: {
                id: carrierRecord.id,
                ...modelFields,
              },
            },
          });
          if (onSuccess) {
            onSuccess(modelFields);
          }
        } catch (err) {
          if (onError) {
            const messages = err.errors.map((e) => e.message).join("\n");
            onError(modelFields, messages);
          }
        }
      }}
      {...getOverrideProps(overrides, "CarrierUpdateForm")}
      {...rest}
    >
      <TextField
        label="Carrier name"
        isRequired={true}
        isReadOnly={false}
        value={carrierName}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              carrierName: value,
              bukcet,
              iataode,
              contractType,
              emailAddress,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.carrierName ?? value;
          }
          if (errors.carrierName?.hasError) {
            runValidationTasks("carrierName", value);
          }
          setCarrierName(value);
        }}
        onBlur={() => runValidationTasks("carrierName", carrierName)}
        errorMessage={errors.carrierName?.errorMessage}
        hasError={errors.carrierName?.hasError}
        {...getOverrideProps(overrides, "carrierName")}
      ></TextField>
      <TextField
        label="Bukcet"
        isRequired={true}
        isReadOnly={false}
        value={bukcet}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              carrierName,
              bukcet: value,
              iataode,
              contractType,
              emailAddress,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.bukcet ?? value;
          }
          if (errors.bukcet?.hasError) {
            runValidationTasks("bukcet", value);
          }
          setBukcet(value);
        }}
        onBlur={() => runValidationTasks("bukcet", bukcet)}
        errorMessage={errors.bukcet?.errorMessage}
        hasError={errors.bukcet?.hasError}
        {...getOverrideProps(overrides, "bukcet")}
      ></TextField>
      <TextField
        label="Iataode"
        isRequired={true}
        isReadOnly={false}
        value={iataode}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              carrierName,
              bukcet,
              iataode: value,
              contractType,
              emailAddress,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.iataode ?? value;
          }
          if (errors.iataode?.hasError) {
            runValidationTasks("iataode", value);
          }
          setIataode(value);
        }}
        onBlur={() => runValidationTasks("iataode", iataode)}
        errorMessage={errors.iataode?.errorMessage}
        hasError={errors.iataode?.hasError}
        {...getOverrideProps(overrides, "iataode")}
      ></TextField>
      <TextField
        label="Contract type"
        isRequired={true}
        isReadOnly={false}
        value={contractType}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              carrierName,
              bukcet,
              iataode,
              contractType: value,
              emailAddress,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.contractType ?? value;
          }
          if (errors.contractType?.hasError) {
            runValidationTasks("contractType", value);
          }
          setContractType(value);
        }}
        onBlur={() => runValidationTasks("contractType", contractType)}
        errorMessage={errors.contractType?.errorMessage}
        hasError={errors.contractType?.hasError}
        {...getOverrideProps(overrides, "contractType")}
      ></TextField>
      <TextField
        label="Email address"
        isRequired={true}
        isReadOnly={false}
        value={emailAddress}
        onChange={(e) => {
          let { value } = e.target;
          if (onChange) {
            const modelFields = {
              carrierName,
              bukcet,
              iataode,
              contractType,
              emailAddress: value,
              isActive,
            };
            const result = onChange(modelFields);
            value = result?.emailAddress ?? value;
          }
          if (errors.emailAddress?.hasError) {
            runValidationTasks("emailAddress", value);
          }
          setEmailAddress(value);
        }}
        onBlur={() => runValidationTasks("emailAddress", emailAddress)}
        errorMessage={errors.emailAddress?.errorMessage}
        hasError={errors.emailAddress?.hasError}
        {...getOverrideProps(overrides, "emailAddress")}
      ></TextField>
      <SwitchField
        label="Is active"
        defaultChecked={false}
        isDisabled={false}
        isChecked={isActive}
        onChange={(e) => {
          let value = e.target.checked;
          if (onChange) {
            const modelFields = {
              carrierName,
              bukcet,
              iataode,
              contractType,
              emailAddress,
              isActive: value,
            };
            const result = onChange(modelFields);
            value = result?.isActive ?? value;
          }
          if (errors.isActive?.hasError) {
            runValidationTasks("isActive", value);
          }
          setIsActive(value);
        }}
        onBlur={() => runValidationTasks("isActive", isActive)}
        errorMessage={errors.isActive?.errorMessage}
        hasError={errors.isActive?.hasError}
        {...getOverrideProps(overrides, "isActive")}
      ></SwitchField>
      <Flex
        justifyContent="space-between"
        {...getOverrideProps(overrides, "CTAFlex")}
      >
        <Button
          children="Reset"
          type="reset"
          onClick={(event) => {
            event.preventDefault();
            resetStateValues();
          }}
          isDisabled={!(idProp || carrierModelProp)}
          {...getOverrideProps(overrides, "ResetButton")}
        ></Button>
        <Flex
          gap="15px"
          {...getOverrideProps(overrides, "RightAlignCTASubFlex")}
        >
          <Button
            children="Submit"
            type="submit"
            variation="primary"
            isDisabled={
              !(idProp || carrierModelProp) ||
              Object.values(errors).some((e) => e?.hasError)
            }
            {...getOverrideProps(overrides, "SubmitButton")}
          ></Button>
        </Flex>
      </Flex>
    </Grid>
  );
}
